import React from 'react'
import AddSvg from '../../../../assets/images/add.svg'
import './Subtitle.scss'

function Subtitle ({ text, onClick, disabled }) {
  return (
    <div className='subtitle-container'>
      <p>{text}</p>
      <div onClick={() => onClick()} className={disabled ? 'subtitle-disabled' : null}>
        <img src={AddSvg} alt='agregar' />
        <p>AGREGAR</p>
      </div>
    </div>
  )
}

export default Subtitle
